/**
 * role模块接口列表
 */
import axios from './utils/https' // 导入http中创建的axios实例

const role = {
  // 获取角色列表
  getRoles () {
    return axios.get('/api/Role/GetRoles')
  },
  // 获取角色列表
  getRolesByNoSystem () {
    return axios.get('/api/Role/GetRolesByNoSystem')
  },
  getIsCompanySystem () {
    return axios.get('/api/Role/GetIsCompanySystem')
  }
}

export default role
